import { ref } from "vue";

const _store = ref();

/**
 * This function is used for "vuex" store to work outside of the Vue components.
 * Because importing `useStore` from "vuex" doesn't work outside of the Vue components, we must make this workaround to make it work.
 * This pattern is a singleton pattern.
 */
export function useStore(store?: unknown) {
  if (store) {
    _store.value = store;
  }
  return _store.value;
}
